export const APP_VERSION = process.env.REACT_APP_VERSION || '0.1.0 default'
export const APP_VERSION_LABEL = `v${APP_VERSION}`
